import React from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { ParagraphSM, TitleSM } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface KingOfKingsCalloutSectionProps {
  isScrollingLayout?: boolean
}

export const KingOfKingsCalloutSection: React.FC<KingOfKingsCalloutSectionProps> = ({ isScrollingLayout = false }) => {
  const { t } = useTranslate('guild')

  return (
    <section
      className={classNames(
        'relative w-full pb-16 lg:pb-20',
        isScrollingLayout
          ? '-mt-[12vh] se:-mt-20 md:-mt-40 lg:-mt-38 z-50'
          : '-mt-[11vh] se:-mt-50 md:-mt-40 lg:-mt-36',
      )}
    >
      {/*Mobile*/}
      <div className="relative sm:hidden">
        <div
          className="mx-6 mb-1 rounded-2xl bg-transparent p-[1px] 3xl:mx-auto 3xl:max-w-[2000px]"
          style={{
            backgroundImage:
              'linear-gradient(166.78deg, #EDD7C6 1.42%, #D6A177 14.6%, #FEDEC6 39.98%, #D48D59 60.48%, #A66141 85.7%, #612B12 94.6%)',
          }}
        >
          <div className="relative">
            <div className="flex rounded-2xl bg-core-gray-900 text-white">
              <div className="mx-8 -mt-16 mb-1 rounded-2xl p-[1px]">
                <div className="relative flex flex-col items-center justify-center">
                  <Image
                    className="w-[160px]"
                    width={376}
                    height={325}
                    alt="Guild Tickets & Jesus"
                    src={'/c_fill,w_376/v1742574425/angel-studios/guild/king-of-kings/GuildTicketsAndJesus.webp'}
                  />
                  <div className="flex py-2 text-center text-white">
                    <div className="w-full sm:w-3/5">
                      <TitleSM
                        weight="bold"
                        className="md:photon-title-md lg:photon-heading-sm xl:photon-heading-md mb-3"
                      >
                        <Translate t={t} i18nKey="premiumMembersTwoTicketsToKingOfKings">
                          Premium Members get two free tickets to The King of Kings!
                        </Translate>
                      </TitleSM>
                      <ParagraphSM color="core-gray-400" weight="medium" className="lg:photon-paragraph-lg">
                        <Translate t={t} i18nKey="andEveryOtherAngelTheatricalEvent">
                          ...and every other Angel theatrical event! You&apos;ll want to bring your kids to see this on
                          the big screen. Simple & flexible booking at participating theaters.
                        </Translate>
                      </ParagraphSM>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*Desktop*/}
      <div className="hidden bg-transparent sm:block">
        <div
          className="mx-12 mb-1 rounded-2xl bg-transparent p-[1px] 3xl:mx-auto 3xl:max-w-[2000px]"
          style={{
            backgroundImage:
              'linear-gradient(166.78deg, #EDD7C6 1.42%, #D6A177 14.6%, #FEDEC6 39.98%, #D48D59 60.48%, #A66141 85.7%, #612B12 94.6%)',
          }}
        >
          <div className="relative">
            <div className="flex rounded-2xl bg-core-gray-900 p-8 text-white">
              <div className="w-full sm:w-3/5">
                <TitleSM weight="bold" className="md:photon-title-md lg:photon-heading-sm xl:photon-heading-md mb-3">
                  <Translate t={t} i18nKey="premiumMembersTwoTicketsToKingOfKings">
                    Premium Members get two free tickets to The King of Kings!
                  </Translate>
                </TitleSM>
                <ParagraphSM color="core-gray-400" weight="medium" className="lg:photon-paragraph-lg">
                  <Translate t={t} i18nKey="andEveryOtherAngelTheatricalEvent">
                    ...and every other Angel theatrical event! You&apos;ll want to bring your kids to see this on the
                    big screen. Simple & flexible booking at participating theaters.
                  </Translate>
                </ParagraphSM>
              </div>
              <div className="relative ml-auto hidden w-1/3 sm:block">
                <Image
                  className="absolute right-0 w-[376px] sm:-top-1/4 sm:block md:-top-1/2 lg:-top-3/4 xl:-top-full"
                  width={376}
                  height={325}
                  alt="Guild Tickets & Jesus"
                  src={'/c_fill,w_376/v1742574425/angel-studios/guild/king-of-kings/GuildTicketsAndJesus.webp'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
